<template>
  <swiper :class="`${$style.swiper}`" :options="swiperOption">
    <swiper-slide
      v-for="item of swiperList"
      :key="item.id"
      :class="$style.swiper_item"
      @click.native="handleLinkTo('giftCenter.details', { giftId: item.id })"
    >
      <img :src="item.icon" />
      <p>{{ item.title }}</p>
      <p>{{ item.description }}</p>
      <button v-if="item.can_get == 1" @click.stop="handleReceiveGift(item)">领取</button>
      <button v-else style="background-color: #9d9d9d" @click.stop="alreadyReceivedGift(item)">
        已领取
      </button>
    </swiper-slide>
  </swiper>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { Toast } from 'vant';
import { reportData } from '@/api/report';
import 'swiper/css/swiper.css'
export default {
  name: 'horLayout',
  props: {
    swiperList: {
      type: Array,
      default: () => []
    },
    plateId: {
      type: [String, Number],
      default: 0
    },
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 4.1,
        spaceBetween: 10,
        width: 380,
        grabCursor: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      },
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  methods: {
    ...mapMutations('giftCenter', {
      SHOW_GIFT_DIALOG: 'SHOW_GIFT_DIALOG',
      SET_GIFT_ITEM: 'SET_GIFT_ITEM'
    }),
    // 路由跳转
    handleLinkTo(name, query) {
      this.$router.push({ name, query })
    },
    // 打开领取礼包弹窗
    handleReceiveGift(item) {
      if (this.plateId) {
        reportData({
          type: 10,
          data_type: 7,
          gift_plate_id: this.plateId
        })
      }
      this.SHOW_GIFT_DIALOG(true)
      this.SET_GIFT_ITEM(item)
    },
    // 点击已领取按钮
    alreadyReceivedGift(item) {
      if (this.plateId) {
        reportData({
          type: 10,
          data_type: 7,
          gift_plate_id: this.plateId
        })
      }
      reportData({
        type: 10,
        data_type: 9,
        gift_set_id: item.id
      })
      // this.SHOW_GIFT_DIALOG(true)
      this.SET_GIFT_ITEM(item)
      this.$bus.$emit('showNormalDialog', 'receivedGift')
    },
  }
}
</script>

<style lang="scss" module>
@import '~@/styles/mixins.scss';
@import '~@/styles/variable.scss';
.swiper {
  margin: 8px 0px 8px 0px;
}
.swiper_item {
  height: 155px !important;
  background-color: #f8f8f8;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 58px;
    height: 58px;
    margin: 9px 14px;
  }
  & > p:nth-child(2) {
    @include ellipsis(1);
    width: 70px;
    text-align: center;
    margin-top: -3px;
    font-size: 10px;
  }
  & > p:nth-child(3) {
    @include ellipsis(3);
    margin: 5px 7px;
    height: 27px;
    color: rgb(159, 159, 159);
    font-size: 8px;
    line-height: 10px;
  }
  button {
    @include clearBtnDefaultStyle;
    padding: 0;
    width: $buttonWidth;
    height: $buttonHeight;
    color: #fff;
    font-size: 10px;
    background-color: $buttonColor;
    border-radius: 15px;
  }
}
</style>
